module.exports = __webpack_public_path__ + "img/horizontal_1_1_9006.5f8f1aad.png";